export default class MainVisual {
    constructor(main) {
        this.main = main;

        this.init();
    }

    init() {
        this.setMVHeight();
        this.setKvChange();
    }

    setMVHeight() {
        const topMargin = 50;
        const aspect = 780 / (1310 + topMargin);
        const mvHeightSettedEvent = new CustomEvent('mvHeightSetted');

        const setVarable = () => {
            const windowAspect = window.innerWidth / window.innerHeight;
            if (windowAspect > aspect) {
                document.documentElement.style.setProperty('--mvHeight', `${window.innerWidth / aspect}px`);
            } else {
                document.documentElement.style.setProperty('--mvHeight', `100svh`);
            }
        };

        if (window.innerWidth >= 960) {
            setVarable();
        }

        window.addEventListener('resize', setVarable);
        window.dispatchEvent(mvHeightSettedEvent);
    }

    setKvChange() {
        const mvBtn = document.querySelector('.js-mainvisual-btn');

        mvBtn.addEventListener('click', () => {
            if (document.body.dataset.startKv != document.body.dataset.endKv) return;
            document.body.removeAttribute('data-kvanim_ended');
            document.body.dataset.startKv = document.body.dataset.startKv == 1 ? 2 : 1;
            this.main.intro.kvIn(0);
        });
    }
}
